export enum FactorType {
  // eslint-disable-next-line no-unused-vars
  Phone = 0,
  // eslint-disable-next-line no-unused-vars
  Audio = 1,
  // eslint-disable-next-line no-unused-vars
  Email = 2,
}
